import React from 'react';
import { Paper, Box, Typography, Divider, TextField, FormControl, InputLabel, Select, MenuItem, Chip } from '@mui/material';
import { CheckCircle, Cancel, Delete } from '@mui/icons-material';
import dayjs from 'dayjs';

const ROLES = [
  { value: 'teacher', label: 'Docente' },
  { value: 'member', label: 'Membro' },
];

const UserDetailsInfo = ({ user }) => {
  const getRoleLabel = (role) => {
    switch (role) {
      case 'admin':
        return 'Amministratore';
      case 'teacher':
        return 'Docente';
      case 'member':
        return 'Membro';
      default:
        return role;
    }
  };

  // const getLevelLabel = (level) => {
  //   switch (level) {
  //     case 0:
  //       return 'Da assegnare';
  //     case 1:
  //       return '1° anno';
  //     case 2:
  //       return '2° anno';
  //     case 3:
  //       return '3° anno';
  //     case 4:
  //       return '4° anno';
  //     case 5:
  //       return '5° anno';
  //     case 6:
  //       return 'Oltre il 5° anno';
  //     default:
  //       return '';
  //   }
  // };

  return (
    <Paper sx={{ p: 3 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
        <Typography variant="h6">
          Informazioni Utente
        </Typography>
      </Box>
      <Divider sx={{ mb: 2 }} />
      
      <Box component="form" sx={{ display: 'flex', flexDirection: 'column', gap: 2, mt: 1 }}>
        {/* Prima riga: Nome e Cognome */}
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            name="name"
            label="Nome"
            value={user?.name || ''}
            sx={{ flex: 1 }}
            InputProps={{ readOnly: true }}
          />
          <TextField
            name="surname"
            label="Cognome"
            value={user?.surname || ''}
            sx={{ flex: 1 }}
            InputProps={{ readOnly: true }}
          />
        </Box>

        {/* Seconda riga: Email e Telefono */}
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            name="email"
            label="Email"
            value={user?.email || ''}
            sx={{ flex: 1 }}
            InputProps={{ readOnly: true }}
          />
          <TextField
            name="telephone"
            label="Telefono"
            value={user?.telephone || ''}
            sx={{ flex: 1 }}
            InputProps={{ readOnly: true }}
          />
        </Box>

        {/* Terza riga: Telefono Secondario e Ruolo */}
        <Box sx={{ display: 'flex', gap: 2 }}>
          <TextField
            name="telephoneSecondary"
            label="Telefono Secondario"
            value={user?.telephoneSecondary || ''}
            sx={{ flex: 1 }}
            InputProps={{ readOnly: true }}
          />
          <FormControl sx={{ flex: 1 }}>
            <InputLabel>Ruolo</InputLabel>
            <Select
              name="roles"
              label="Ruolo"
              value={user?.roles || []}
              multiple
              disabled
              renderValue={(selected) => (
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                  {selected.map((role) => (
                    <Chip key={role} label={getRoleLabel(role)} size="small" />
                  ))}
                </Box>
              )}
            >
              {ROLES.map((role) => (
                <MenuItem key={role.value} value={role.value}>
                  {role.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>

        {/* Anno di Corso - solo per membri */}
        {user?.roles?.includes('member') && (
          <FormControl fullWidth>
            <InputLabel>Anno di Corso</InputLabel>
            <Select
              name="level"
              label="Anno di Corso"
              value={user?.level !== undefined ? user.level : ''}
              disabled
            >
              <MenuItem value={0}>Da assegnare</MenuItem>
              <MenuItem value={1}>1° anno</MenuItem>
              <MenuItem value={2}>2° anno</MenuItem>
              <MenuItem value={3}>3° anno</MenuItem>
              <MenuItem value={4}>4° anno</MenuItem>
              <MenuItem value={5}>5° anno</MenuItem>
              <MenuItem value={6}>Oltre il 5° anno</MenuItem>
            </Select>
          </FormControl>
        )}
      </Box>

      {/* Sezione Consensi */}
      <Divider sx={{ my: 3 }} />
      <Box>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Consensi
        </Typography>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {user?.flagStatuto ? <CheckCircle color="success" /> : <Cancel color="error" />}
            <Typography variant="body2">
              Statuto dell'associazione: {user?.flagStatuto ? 'Accettato' : 'Non accettato'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {user?.flagPrivacy ? <CheckCircle color="success" /> : <Cancel color="error" />}
            <Typography variant="body2">
              Privacy Policy: {user?.flagPrivacy ? 'Accettata' : 'Non accettata'}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {user?.flagPicture ? <CheckCircle color="success" /> : <Cancel color="error" />}
            <Typography variant="body2">
              Liberatoria foto: {user?.flagPicture ? 'Accettata' : 'Non accettata'}
            </Typography>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default UserDetailsInfo;

